let DOMAIN = "http://localhost:8080"
DOMAIN = "https://api-dev.digiamerica.us";

const config: EnvironmentConfig = {
  "domain": "login-dev.digiamerica.us",
  "clientId": "2RNYkOxIbxJbeMK8iLPDe9UETe0j7P1e",
  "authorizationParams": {
    "audience": "api://api-dev.digiamerica.us"
  },
  "apiUri": `${DOMAIN}`,
  "appUri": `${DOMAIN}`,
  "errorPath": "/error"
};

const { domain, clientId, authorizationParams: { audience }, apiUri, errorPath } = config;

export const PRODUCT_URL = `${DOMAIN}/v1/products`;
export const QUOTE_URL = `${DOMAIN}/v1/quotes`;
export const USER_URL = `${DOMAIN}/v1/users`
export const DEAL_DESK_URL = `${DOMAIN}/v1/deal-desk`
export const REPORT_URL = `${DOMAIN}/v1/reports`

export const environment = {
  production: false,
  auth: {
    domain,
    clientId,
    authorizationParams: {
      ...(audience && audience !== 'YOUR_API_IDENTIFIER' ? { audience } : null),
      redirect_uri: window.location.origin,
    },
    errorPath,
  },
  httpInterceptor: {
    allowedList: [`${apiUri}/*`],
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/plugins/zone-error';  // Included with Angular CLI.import { EnvironmentConfig } from './EnvironmentConfig';import { EnvironmentConfig } from '../types/EnvironmentConfig';
import { EnvironmentConfig } from '../types/EnvironmentConfig';

